import { useEffect } from 'react'

import { useBootstrap } from '@/hooks/useBootstrap'

/**
 * Záložka prehliadača podľa školy - jej ikona a názov.
 *
 * Prečo to robí JavaScript a nie `index.html`: aplikáciu obsluhuje jeden
 * build pre všetky školy a to, ktorá škola to je, sa zistí až z domény pri
 * načítaní. Statická značka v HTML by musela byť pre všetky rovnaká.
 *
 * Ikona sa vyrába zo školského loga na serveri (`apps/core/branding.py`) -
 * logo je obdĺžnik, favicon štvorec, a prehliadač by z neho spravil pásik.
 * Kým škola logo nemá, zostáva ikona pribalená v builde.
 */
export function useBranding() {
  const { data } = useBootstrap()
  const favicon = data?.settings.favicon_url
  const name = data?.settings.display_system_name

  useEffect(() => {
    if (!favicon) return

    // `index.html` má predvolenú značku, aby záložka nebola prázdna, kým sa
    // škola načíta; tu sa jej len prepíše adresa. Vytvára sa len pre prípad,
    // že by v dokumente chýbala.
    let link = document.querySelector<HTMLLinkElement>("link[rel='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.type = 'image/x-icon'
    link.href = favicon
  }, [favicon])

  useEffect(() => {
    if (name) document.title = name
  }, [name])
}
